// Import type declarations
import './types/window.d.ts'

// Local interface for the config structure
interface AppConfig {
  api: {
    baseUrl: string
    timeout: number
    headers: {
      'Content-Type': string
    }
  }
  app: {
    name: string
    version: string
  }
  maps: {
    apiKey?: string
  }
}

// Configuration types
interface Config {
  getApiHost: () => string
  api: {
    timeout: number
    headers: {
      'Content-Type': string
    }
  }
  app: {
    name: string
    version: string
  }
}

// Get runtime configuration with fallbacks
const getRuntimeConfig = (): AppConfig => {
  // Check if runtime config is available
  if (typeof window !== 'undefined' && window.APP_CONFIG) {
    return window.APP_CONFIG
  }
  
  // Fallback configuration for development or if runtime config is not available
  return {
    api: {
      baseUrl: 'http://localhost:8080/api/v1',
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    },
    app: {
      name: 'Tiering.de',
      version: '1.0.0'
    },
    maps: {}
  }
}

// Configuration file using runtime configuration
const config: Config = {
  // Get API host from runtime configuration
  getApiHost: (): string => {
    const runtimeConfig = getRuntimeConfig()
    return runtimeConfig.api.baseUrl
  },

  // API configuration from runtime config
  get api() {
    const runtimeConfig = getRuntimeConfig()
    return runtimeConfig.api
  },

  // App configuration from runtime config
  get app() {
    const runtimeConfig = getRuntimeConfig()
    return runtimeConfig.app
  },
}

// Export the API base URL
export const API_BASE_URL: string = config.getApiHost()

// Export full config
export default config

// Export runtime config getter for direct access
export const getRuntimeAppConfig = getRuntimeConfig